import { render, staticRenderFns } from "./SSOCallback.vue?vue&type=template&id=9ade61a0"
import script from "./SSOCallback.vue?vue&type=script&lang=js"
export * from "./SSOCallback.vue?vue&type=script&lang=js"
import style0 from "./SSOCallback.vue?vue&type=style&index=0&id=9ade61a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports